import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class FwHttpService {

  static root = 'https://maritime-photographie.de/dev/api/';
  static searchRoot = 'https://maritime-photographie.de/search/';

  constructor(private http: HttpClient) { }

  public get<T>(path: string) {
    return this.http.get<T>(FwHttpService.root + path);
  }

  public getSearch<T>(path: string) {
    return this.http.get<T>(FwHttpService.searchRoot + path);
  }
}
